import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ServiceList = ({ className = '', limit = null }) => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(1); // default active

  const services = t('sections.serviceList.services', { returnObjects: true, defaultValue: [
    { num: '01', title: 'Cloud Security Posture Management', img: 'assets/img/service/service2-1.jpg', text: 'Continuously assess your cloud environments for misconfigurations, vulnerabilities, and deviations from security best practices.' },
    { num: '02', title: 'Cloud Workload Protection Platform', img: 'assets/img/service/service2-2.jpg', text: 'Safeguard your cloud-based workloads and containers from a wide range of threats, including malware, ransomware.' },
    { num: '03', title: 'Cloud Access Security Broker', img: 'assets/img/service/service2-3.jpg', text: 'Safeguard sensitive data shared with cloud applications by enforcing granular access controls, monitoring.' },
    { num: '04', title: 'Endpoint Detection and Response', img: 'assets/img/service/service2-4.jpg', text: 'Proactively detect, investigate, and respond to advanced threats targeting your endpoints.' }
  ] });

  const displayedServices = limit ? services.slice(0, limit) : services;

  return (
    <>
      {displayedServices.map((service, index) => (
        <div className={className} key={index}>
          <div
            className={`service-list hover-item ${
              activeIndex === index ? 'item-active' : ''
            }`}
            onMouseEnter={() => setActiveIndex(index)}
          >
            <div className="box-number">{service.num}</div>

            <div className="box-content">
              <h3 className="box-title">
                <Link to="/service-details">{service.title}</Link>
              </h3>
              <p className="box-text">{service.text}</p>
            </div>

            <div className="box-img">
              <img src={service.img} alt={service.title} />
            </div>

            <div className="btn-wrap">
              <Link to="/service-details" className="ot-btn style-border">
                {t('sections.serviceList.read_more','Read More')} <i className="far fa-long-arrow-right ms-2"></i>
              </Link>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ServiceList;
